import {
  chakra,
  Box, Stack, VStack, HStack,
  Text, Image, Heading
} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';

function SocialMediaLink({href, alt, src}: {href: string, alt: string, src: string}) {
  return (
    <Box w={`${28/16}rem`}><chakra.a href={href} target={alt}><Image src={src} alt={alt} /></chakra.a></Box>
  );
}

export default function Message() {
  return (
    <chakra.section mt={`${157/16}rem`}>
      <Stack
        direction={['column', 'column', 'row']}
        align="flex-start"
        maxW={['contentSm', 'contentSm', 'content']}
        mx="auto"
        pt={[7, 7, "14"]}
        px={[7, 7, "14"]}
        pb={[12, 12, "24"]}
        border="solid 1px"
        spacing="2.75rem"
        borderRadius="3xl"
      >
        <VStack flex="1" spacing={`${26/16}rem`} align={['center', 'center', 'flex-start']}>
          <Box>
            <Image src={`${IMAGE_PREFIX}img-graph-06.jpg`} alt="平野啓一郎近影" />
          </Box>
          <VStack spacing="5" align={['center', 'center', 'flex-start']}>
            <Heading fontSize={`${28/16}rem`} letterSpacing="0.328125rem" lineHeight="1" textAlign={['center', 'center', 'start']}>
              <HStack flexWrap="wrap" justify={['center', 'center', 'flex-start']} gap="4" spacing="0" lineHeight={[1, 1, 0.7]}>
                <chakra.span>平野啓一郎</chakra.span>
                <chakra.span
                  display={['block', 'block', 'inline']}
                  mt={[2, 2, 0]}
                  fontSize="lg"
                  letterSpacing="0.05em"
                  fontWeight="inherit"
                  fontFamily="inherit"
                >Keiichiro Hirano</chakra.span>
              </HStack>
            </Heading>
            <Text lineHeight="1"><chakra.a href="https://k-hirano.com/" target="hirano-site">https://k-hirano.com/</chakra.a></Text>
            <HStack spacing="5">
              <SocialMediaLink href="https://twitter.com/hiranok" alt="Twitter" src={`${IMAGE_PREFIX}icon-graph-sns-tw.png`} />
              <SocialMediaLink href="https://www.instagram.com/hiranok/" alt="Instagram" src={`${IMAGE_PREFIX}icon-graph-sns-ig.png`} />
              <SocialMediaLink href="https://www.facebook.com/hiranokf" alt="Facebook" src={`${IMAGE_PREFIX}icon-graph-sns-fb.png`} />
              <SocialMediaLink href="https://line.me/R/ti/p/%40hiranokeiichiro" alt="LINE" src={`${IMAGE_PREFIX}icon-graph-sns-line.png`} />
            </HStack>
          </VStack>
        </VStack>
        <Box flex="1" fontSize={['md', 'md', "lg"]}>
          <Text>「分人」とは、自分とは何か？を考えるための一つのモデルです。「個人」を他者との関係を通じてより細分化した主体の単位であり、それ自体としては、ニュートラルな分析概念です。「分人化」は、自分自身に於いても、他者に於いても、観察可能な現象です。</Text>
          <Text mt="1em">複数から成る分人の構成と比率は、各人それぞれに異なっており、そのバランスはシンプルなものから複雑なものまで多様です。好ましい分人もあれば、ストレスとなる分人もあるでしょう。<br />
          分人という概念を用いて自己を把握し、他者との関係を再認識することは、抽象的な思考に留まらない、人生の具体的な対処です。</Text>
        </Box>
      </Stack>
    </chakra.section>
  );
}
